  (() => {
    const section = document.querySelector('.shopify-section--main-article');

    if (!section) {
      return;
    }

    const slugify = (text) => text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\u4e00-\u9fa5]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const setupReadingSystem = () => {
      const headings = Array.from(section.querySelectorAll('.article-body-flow > .prose > h2'))
        .filter((heading) => heading.textContent.trim().length > 0);
      const toc = section.querySelector('.article-reading-toc');
      const tocList = section.querySelector('.article-reading-toc__list');
      const usedIds = new Set();

      headings.forEach((heading, index) => {
        const baseId = heading.id || `section-${slugify(heading.textContent) || index + 1}`;
        let uniqueId = baseId;
        let suffix = 2;

        while (usedIds.has(uniqueId) || document.getElementById(uniqueId)) {
          if (heading.id === uniqueId) {
            break;
          }

          uniqueId = `${baseId}-${suffix}`;
          suffix += 1;
        }

        usedIds.add(uniqueId);
        heading.id = uniqueId;
      });

      if (toc && tocList && headings.length > 1) {
        tocList.innerHTML = '';

        headings.slice(0, 8).forEach((heading) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'article-reading-toc__link';
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          tocList.append(item);
        });

        toc.hidden = false;
      }

      const firstParagraph = section.querySelector('.article-body-flow > .prose:first-child > p:first-child');

      if (firstParagraph && firstParagraph.querySelector('strong')) {
        firstParagraph.classList.add('article-key-takeaway');
      }

      const signalVariants = [
        { test: /^(warning:|caution:|important:)/, classes: ['article-signal-note', 'article-signal-note--warning'] },
        { test: /^(quick answer:|tl;dr:|bottom line:)/, classes: ['article-signal-note', 'article-signal-note--quick'] },
        { test: /^(tip:|pro tip:|note:)/, classes: ['article-signal-note', 'article-signal-note--tip'] },
        { test: /^(best for:|avoid if:|baporssa route:|expert note:)/, classes: ['article-signal-note'] }
      ];

      section.querySelectorAll('.article-body-flow > .prose > p').forEach((paragraph) => {
        const text = paragraph.textContent.trim().toLowerCase();
        const match = signalVariants.find((variant) => variant.test.test(text));

        if (match) {
          paragraph.classList.add(...match.classes);
        }
      });
    };

    const plainText = (element) => element.textContent.replace(/\s+/g, ' ').trim();

    const setupFaqModule = () => {
      const faqHeading = Array.from(section.querySelectorAll('.article-body-flow > .prose > h2, .article-body-flow > .prose > h3'))
        .find((heading) => /^(faq|faqs|frequently asked questions|常见问题)$/i.test(plainText(heading)));

      if (!faqHeading || faqHeading.dataset.faqEnhanced === 'true') {
        return;
      }

      const faqPairs = [];
      let node = faqHeading.nextElementSibling;

      while (node && !node.matches('h2')) {
        if (node.matches('h3, h4, h5')) {
          const question = plainText(node);
          const answerNodes = [];
          let answerNode = node.nextElementSibling;

          while (answerNode && !answerNode.matches('h2, h3, h4, h5')) {
            const nextAnswerNode = answerNode.nextElementSibling;

            if (plainText(answerNode) !== '') {
              answerNodes.push(answerNode);
            }

            answerNode = nextAnswerNode;
          }

          if (question && answerNodes.length > 0) {
            faqPairs.push({ question, questionNode: node, answerNodes });
          }

          node = answerNode;
          continue;
        }

        node = node.nextElementSibling;
      }

      if (faqPairs.length === 0) {
        return;
      }

      const faqModule = document.createElement('div');
      const faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: []
      };

      faqModule.className = 'article-faq-module';

      faqPairs.forEach((pair, index) => {
        const item = document.createElement('details');
        const summary = document.createElement('summary');
        const answer = document.createElement('div');
        const icon = document.createElement('span');
        item.className = 'article-faq-module__item';
        summary.className = 'article-faq-module__summary';
        answer.className = 'article-faq-module__answer';
        icon.className = 'article-faq-module__icon';
        const questionText = document.createElement('span');
        questionText.textContent = pair.question;
        summary.append(questionText, icon);

        if (index === 0) {
          item.open = true;
        }

        pair.answerNodes.forEach((answerNode) => {
          answer.append(answerNode);
        });

        item.append(summary, answer);
        faqModule.append(item);
        pair.questionNode.classList.add('article-faq-source');

        faqSchema.mainEntity.push({
          '@type': 'Question',
          name: pair.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: plainText(answer)
          }
        });
      });

      faqHeading.after(faqModule);
      faqHeading.dataset.faqEnhanced = 'true';

      const hasExistingFaqSchema = Array.from(document.querySelectorAll('script[type="application/ld+json"]'))
        .some((script) => /["']@type["']\s*:\s*["']FAQPage["']/.test(script.textContent || ''));

      if (faqSchema.mainEntity.length > 0 && !hasExistingFaqSchema && !section.querySelector('script[data-article-faq-schema]')) {
        const schemaScript = document.createElement('script');
        schemaScript.type = 'application/ld+json';
        schemaScript.dataset.articleFaqSchema = 'true';
        schemaScript.textContent = JSON.stringify(faqSchema);
        section.append(schemaScript);
      }
    };

    const setupCompactProductCards = () => {
      section.querySelectorAll('[data-article-product-card]').forEach((card) => {
        if (card.dataset.compactProductEnhanced === 'true') {
          return;
        }

        const variantButtons = Array.from(card.querySelectorAll('[data-article-product-variant]'));

        if (variantButtons.length === 0) {
          return;
        }

        const links = Array.from(card.querySelectorAll('[data-article-product-link]'));
        const image = card.querySelector('[data-article-product-image]');
        const price = card.querySelector('[data-article-product-price]');
        const compare = card.querySelector('[data-article-product-compare]');
        const selectedOption = card.querySelector('[data-article-product-selected-option]');

        const selectVariant = (selectedButton) => {
          variantButtons.forEach((button) => {
            const isSelected = button === selectedButton;
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });

          if (selectedButton.dataset.variantUrl) {
            links.forEach((link) => {
              link.href = selectedButton.dataset.variantUrl;
            });
          }

          if (price && selectedButton.dataset.variantPrice) {
            price.textContent = selectedButton.dataset.variantPrice;
          }

          if (compare) {
            const comparePrice = selectedButton.dataset.variantCompare || '';
            compare.textContent = comparePrice;
            compare.hidden = comparePrice === '';
          }

          if (selectedOption && selectedButton.dataset.variantLabel) {
            selectedOption.textContent = selectedButton.dataset.variantLabel;
          }

          if (image && selectedButton.dataset.variantImage) {
            image.src = selectedButton.dataset.variantImage;
            image.removeAttribute('srcset');

            if (selectedButton.dataset.variantImageAlt) {
              image.alt = selectedButton.dataset.variantImageAlt;
            }
          }
        };

        variantButtons.forEach((button) => {
          button.addEventListener('click', () => selectVariant(button));
        });

        card.dataset.compactProductEnhanced = 'true';
      });
    };

    const setupProductSliders = () => {
      section.querySelectorAll('.article-inline-product-grid').forEach((track) => {
        const cards = Array.from(track.children).filter((child) => child.classList.contains('article-inline-product-card'));

        if (cards.length > 1) {
          track.classList.add('article-inline-product-grid--multi');
        }

        if (cards.length > 2) {
          track.classList.add('article-inline-product-grid--triple');
        }
      });

      section.querySelectorAll('.article-inline-product-grid--multi').forEach((track, index) => {
        if (track.dataset.productSliderEnhanced === 'true') {
          return;
        }

        const cards = Array.from(track.children).filter((child) => child.classList.contains('article-inline-product-card'));
        const existingControls = track.nextElementSibling && track.nextElementSibling.classList.contains('article-inline-products-slider__controls')
          ? track.nextElementSibling
          : null;

        if (cards.length <= 1) {
          if (existingControls) {
            existingControls.hidden = true;
          }
          return;
        }

        const controls = document.createElement('div');
        const progress = document.createElement('div');
        const progressBar = document.createElement('span');
        const buttons = document.createElement('div');
        const previousButton = document.createElement('button');
        const nextButton = document.createElement('button');

        track.dataset.productSliderEnhanced = 'true';
        track.setAttribute('role', 'region');
        track.setAttribute('aria-label', `Product recommendations ${index + 1}`);
        controls.className = 'article-inline-products-slider__controls';
        progress.className = 'article-inline-products-slider__progress';
        progressBar.className = 'article-inline-products-slider__progress-bar';
        buttons.className = 'article-inline-products-slider__buttons';
        previousButton.className = 'article-inline-products-slider__button';
        nextButton.className = 'article-inline-products-slider__button';
        previousButton.type = 'button';
        nextButton.type = 'button';
        previousButton.setAttribute('aria-label', 'Previous product');
        nextButton.setAttribute('aria-label', 'Next product');
        previousButton.innerHTML = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M9 2 4 7l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        nextButton.innerHTML = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="m5 2 5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        progress.append(progressBar);
        buttons.append(previousButton, nextButton);
        controls.append(progress, buttons);
        track.after(controls);

        const updateControls = () => {
          const scrollableWidth = track.scrollWidth - track.clientWidth;

          if (scrollableWidth <= 1) {
            controls.hidden = true;
            previousButton.disabled = true;
            nextButton.disabled = true;
            progressBar.style.setProperty('--article-product-progress', '100%');
            return;
          }

          controls.hidden = false;
          const progressValue = (track.scrollLeft / scrollableWidth) * 100;
          progressBar.style.setProperty('--article-product-progress', `${Math.max(8, Math.min(100, progressValue))}%`);
          previousButton.disabled = track.scrollLeft <= 1;
          nextButton.disabled = track.scrollLeft >= scrollableWidth - 1;
        };

        const scrollByCard = (direction) => {
          const firstCard = cards[0];
          const trackStyles = window.getComputedStyle(track);
          const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 16;
          const amount = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth * 0.9;
          track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        };

        previousButton.addEventListener('click', () => scrollByCard(-1));
        nextButton.addEventListener('click', () => scrollByCard(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls);
        updateControls();
      });
    };

    const normalizeTableText = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

    const classifyTable = (headerCells, bodyRows) => {
      const headerLabels = headerCells.map((cell) => plainText(cell));
      const headerText = normalizeTableText(headerLabels.join(' | '));
      const columnCount = Math.max(headerCells.length, ...bodyRows.map((row) => row.cells.length));
      let tableType = 'comparison';

      if (/\b\d+\s*points?\b|score|rating/.test(headerText)) {
        tableType = 'score';
      } else if (/baporssa|route|path|recommended|recommendation|product/.test(headerText)) {
        tableType = 'route';
      } else if (/avoid|choose|better direction|be careful|tradeoff|quick fix|what to do|best for/.test(headerText)) {
        tableType = 'decision';
      } else if (/material|lens|uv|vlt|category|feature|condition|situation|benefit/.test(headerText)) {
        tableType = 'spec';
      }

      return {
        columnCount,
        rowCount: bodyRows.length,
        tableType,
        preserveMatrixOnDesktop: columnCount <= 3 && bodyRows.length <= 6 && !['route', 'score'].includes(tableType)
      };
    };

    const tableItemModifier = (label) => {
      const normalized = normalizeTableText(label);

      if (/baporssa|route|path|product|recommendation|recommended/.test(normalized)) {
        return ' article-table-card__item--route';
      }

      if (/\b\d+\s*points?\b|score|rating/.test(normalized)) {
        return ' article-table-card__item--score';
      }

      if (/choose|better|best|what to do|quick fix/.test(normalized)) {
        return ' article-table-card__item--positive';
      }

      if (/avoid|be careful|tradeoff/.test(normalized)) {
        return ' article-table-card__item--caution';
      }

      return '';
    };

    const enhanceTable = (table, index) => {
      const wrapper = table.closest('.article-table-scroll') || table.parentElement;

      if (!wrapper || wrapper.dataset.tableCardsEnhanced === 'true') {
        return;
      }

      const rows = Array.from(table.rows);

      if (rows.length < 2) {
        return;
      }

      let headerCells = [];
      let bodyRows = [];

      if (table.tHead && table.tHead.rows.length > 0) {
        headerCells = Array.from(table.tHead.rows[0].cells);
        bodyRows = Array.from(table.tBodies).flatMap((body) => Array.from(body.rows));
      } else if (Array.from(rows[0].cells).some((cell) => cell.tagName === 'TH')) {
        headerCells = Array.from(rows[0].cells);
        bodyRows = rows.slice(1);
      } else {
        headerCells = Array.from(rows[0].cells).map((cell, cellIndex) => ({ textContent: cellIndex === 0 ? 'Item' : `Detail ${cellIndex}` }));
        bodyRows = rows;
      }

      if (bodyRows.length === 0) {
        return;
      }

      const tableMeta = classifyTable(headerCells, bodyRows);
      const module = document.createElement('div');
      const track = document.createElement('div');
      const controls = document.createElement('div');
      const progress = document.createElement('div');
      const progressBar = document.createElement('span');
      const buttons = document.createElement('div');
      const previousButton = document.createElement('button');
      const nextButton = document.createElement('button');
      module.className = `article-table-cards article-table-cards--${tableMeta.tableType}`;
      module.setAttribute('role', 'region');
      module.setAttribute('aria-label', table.getAttribute('aria-label') || `Comparison cards ${index + 1}`);
      module.dataset.articleTableType = tableMeta.tableType;
      track.className = 'article-table-cards__track';
      controls.className = 'article-table-cards__controls';
      progress.className = 'article-table-cards__progress';
      progressBar.className = 'article-table-cards__progress-bar';
      buttons.className = 'article-table-cards__buttons';
      previousButton.className = 'article-table-cards__button';
      nextButton.className = 'article-table-cards__button';
      previousButton.type = 'button';
      nextButton.type = 'button';
      previousButton.setAttribute('aria-label', 'Previous comparison card');
      nextButton.setAttribute('aria-label', 'Next comparison card');
      previousButton.innerHTML = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M9 2 4 7l5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      nextButton.innerHTML = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="m5 2 5 5-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      progress.append(progressBar);
      buttons.append(previousButton, nextButton);
      controls.append(progress, buttons);
      module.append(track, controls);

      bodyRows.forEach((row, rowIndex) => {
        const cells = Array.from(row.cells);

        if (cells.length === 0) {
          return;
        }

        const card = document.createElement('article');
        const badge = document.createElement('div');
        const title = document.createElement('h3');
        const details = document.createElement('dl');
        card.className = 'article-table-card';
        badge.className = 'article-table-card__index';
        title.className = 'article-table-card__title';
        details.className = 'article-table-card__details';
        badge.textContent = String(rowIndex + 1).padStart(2, '0');
        title.innerHTML = cells[0].innerHTML;

        cells.slice(1).forEach((cell, cellIndex) => {
          const item = document.createElement('div');
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          const header = headerCells[cellIndex + 1];
          const labelText = (header && header.textContent.trim()) || `Detail ${cellIndex + 1}`;
          item.className = `article-table-card__item${tableItemModifier(labelText)}`;
          label.className = 'article-table-card__label';
          value.className = 'article-table-card__value';
          label.textContent = labelText;
          value.innerHTML = cell.innerHTML;
          item.append(label, value);
          details.append(item);
        });

        card.append(badge, title, details);
        track.append(card);
      });

      if (!track.children.length) {
        return;
      }

      wrapper.dataset.tableCardsEnhanced = 'true';
      wrapper.dataset.articleTableType = tableMeta.tableType;
      wrapper.classList.add('article-table-scroll--cards');
      wrapper.classList.add(`article-table-scroll--${tableMeta.tableType}`);
      wrapper.classList.toggle('article-table-scroll--matrix', tableMeta.preserveMatrixOnDesktop);
      wrapper.classList.toggle('article-table-scroll--cards-desktop', !tableMeta.preserveMatrixOnDesktop);
      table.dataset.articleTableType = tableMeta.tableType;
      wrapper.prepend(module);

      const updateControls = () => {
        const scrollableWidth = track.scrollWidth - track.clientWidth;

        if (bodyRows.length <= 3 || scrollableWidth <= 1) {
          controls.hidden = true;
          previousButton.disabled = true;
          nextButton.disabled = true;
          progressBar.style.setProperty('--article-table-progress', '100%');
          return;
        }

        controls.hidden = false;
        const progressValue = scrollableWidth > 0 ? (track.scrollLeft / scrollableWidth) * 100 : 100;
        progressBar.style.setProperty('--article-table-progress', `${Math.max(8, Math.min(100, progressValue))}%`);
        previousButton.disabled = track.scrollLeft <= 1;
        nextButton.disabled = track.scrollLeft >= scrollableWidth - 1;
      };

      const scrollByCard = (direction) => {
        const firstCard = track.querySelector('.article-table-card');
        const amount = firstCard ? firstCard.getBoundingClientRect().width + 16 : track.clientWidth * 0.9;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => scrollByCard(-1));
      nextButton.addEventListener('click', () => scrollByCard(1));
      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    };

    setupReadingSystem();
    setupFaqModule();
    setupCompactProductCards();
    setupProductSliders();
    section.querySelectorAll('.article-body-flow table').forEach(enhanceTable);
  })();